import { render, staticRenderFns } from "./ProjectSummaryBoxHeader.vue?vue&type=template&id=d8fc9c1a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports